import React from "react";
import { TailSpin } from "react-loader-spinner";
import { useTheme } from "styled-components";

const Loading = () => {
    const theme = useTheme()
	return (
		<TailSpin
			height="80"
			width="80"
			color={theme.primary}
			ariaLabel="tail-spin-loading"
			radius="1"
			wrapperStyle={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
			}}
			visible={true}
		/>
	);
};

export default Loading;
